import React, { useEffect } from 'react'
import './index.css'
import { ConfigProvider } from 'antd'
import RootRoutes from './routes'
import store from './redux/store'
import { Provider } from 'react-redux'
import TagManager from 'react-gtm-module'
import { analytics } from './utils/firebase'

const App: React.FC = () => {
  useEffect(() => {
    // Initialize GTM
    const tagManagerArgs = {
      gtmId: process.env.REACT_APP_SELLER_GOOGLE_TAG_MANAGER_ID || 'GTM-PFLXMT74',
    }
    TagManager.initialize(tagManagerArgs)

    // Log Firebase Analytics
    if (analytics) {
      // console.log('Firebase Analytics initialized')
    }
  }, [])

  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: '"DM Sans", sans-serif',
          colorPrimary: '#b8131b',
        },
      }}
    >
      <Provider store={store}>
        <RootRoutes />
      </Provider>
    </ConfigProvider>
  )
}

export default App
